import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IdexService } from 'app/idex.service';
import { Mimetype } from 'app/shared/mimetype';

declare let $: any;

@Component({
   selector: 'app-dropbox-folders',
   templateUrl: './dropbox-folders.component.html',
   styleUrls: ['../folders/folders.component.css'],
   animations: [
      trigger('state', [
         state('collapse', style({ height: 0 })),
         state('expand', style({ height: '*' })),
         transition('collapse => expand', animate('400ms ease-in')),
         transition('expand => collapse', animate('400ms ease-out'))
      ])
   ]
})
export class DropBoxFoldersComponent {

   @Input() tin: string;
   @Input() parent = '';
   @Input() path = '';
   @Input() parentPath = '';
   @Input() move = false;
   @Input() exportPath = false;
   @Input() selectFile = false;
   @Input() selectSite = false;
   @Input() select_id: any;
   @Input() dropPath: string;
   @Input() access_token: string;
   @Input() selectedItems: any;
   @Input() typeName: any;

   m = false;
   animationState = 'collapse';
   folders: any[] = [];
   loading = false;
   error: string;
   selectedItem: any;
   selected: boolean;
   isSelect: boolean;

   @Output() selectPath = new EventEmitter<boolean>();
   @Output() getPath = new EventEmitter<any>();
   @Output() errorHandler = new EventEmitter<any>();

   constructor(private router: Router, private service: IdexService) {
   }

   toggle() {
      this.loading = true;
      if (this.isExpanded()) {
         this.setAnimationState();
         this.loading = false;
      } else {
         const enconded = encodeURIComponent(this.dropPath.slice(1));
         if (this.exportPath) {
            this.service.getListFileDropbox(this.access_token, enconded)
               .subscribe(res => {
                  this.folders = res.entries.filter((file) => file.mimeType === 'application/octet-stream').sort(this.sortName);
                  this.setAnimationState();
               }, error => {
                  this.error = error;
               }).add(() => {
               this.loading = false;
            });
         } else {
            this.service.getListFileDropbox(this.access_token, enconded)
               .subscribe(res => {
                  this.folders = res.entries.sort(this.sortName);
                  this.setAnimationState();
               }, error => {
                  this.error = error;
               }).add(() => {
               this.loading = false;
            });

         }
      }
   }

   setAnimationState(){
      setTimeout(() => {
         this.animationState = this.animationState === 'collapse' ? 'expand' : 'collapse';
      }, 100);
   }

   sortName(a, b) {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
         return -1;
      }
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
         return 1;
      }
      return 0;
   }

   isExpanded(): boolean {
      return this.animationState === 'expand';
   }

   getFragment(name: string): string {
      return this.path ? this.path + '/' + name : name;
   }

   select(name: any, sub: any,isFolder: boolean) {
      if (this.isSelect) {
         if(this.exportPath){
            $('.selectedPath').removeClass('selectedPath');
            document.getElementById('export_' + this.replaceIdDropBox(name.pathLower)).classList.add('selectedPath');
         }
         if (!sub.isExpanded() && isFolder) {
            sub.toggle();
         }
         if (this.selectedItem === sub) {
            return;
         }
         if (this.selectedItem) {
            this.selectedItem.selected = false;
         }
         this.selectedItem = sub;
         sub.selected = true;
      }
   }

   onSelectPath(agreed: any) {
      if(this.exportPath){
         this.selectPath.emit(agreed);
         this.isSelect = true;
      }else{
         if (agreed.file) {
            this.selectPath.emit(agreed);
            this.isSelect = true;
         } else {
            this.isSelect = false;
         }
      }

   }

   replaceIdDropBox(id): string {
      return id.replaceAll("/","_").replaceAll(" ","_");
   }

   onGetPath(name) {
      if (this.isSelect || this.exportPath) {
         this.getPath.emit(this.parentPath + name);
      }
   }


   expand(folders: any,isFolder: boolean) {
      if (!folders.isExpanded() && isFolder) {
         folders.toggle();
      }
   }

   getIconDropBox(item: any): string {
      return Mimetype.getIconDropbox(item);
   }

   dropBoxIgnoreFileType(item: any): boolean {
      return !Mimetype.validateExtension(item.mimeType, this.typeName,'dropbox');
   }

   dropBoxIsFolder(item: any): boolean {
      const type = Mimetype.getIconDropbox(item);
      return type === 'assets/icons/folder.svg';
   }

   selectFiles(event: any, item: any, uploadType: 'zDox' | 'google drive' | 'onedrive' | 'dropbox') {
      if(Mimetype.validateExtension(item.mimeType, this.typeName,'dropbox')){
            this.manageFiles(event,item,uploadType);
      }
   }

   manageFiles(event: any, item: any, uploadType: 'zDox' | 'google drive' | 'onedrive'| 'dropbox'){
      event.preventDefault();
      item.selected = !item.selected;
      const index = this.selectedItems.indexOf(item);
      if (item.selected) {
         if (index === -1) {
            item.uploadType = uploadType;
            this.selectedItems.push(item);
         }
      } else {
         if (index !== -1) {
            this.selectedItems.splice(index, 1);
         }
      }
   }
}
